module.exports = __webpack_public_path__ + "static/media/porductos_altena__extrafina.e4bcc70d.jpg";